import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "../../../../../../../components/MessageWithLink/types";

export enum TaxableBenefits {
  CAR = "Car",
  CHILDCARE = "Childcare",
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal Allowance",
  NON_CASH_GIFTS_AND_AWARDS = "Non-Cash Gifts & Awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK = "Remote Work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.CAR]: {
    text: "Cash allowance for Car is fully taxable to the employee. If a company car is available to the employee for personal use, the employer pays Fringe Benefit Tax based on the car's value.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.LOANS]: {
    text: "Employee receives the benefit tax-free. Employer pays Fringe Benefit Tax.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.NON_CASH_GIFTS_AND_AWARDS]: {
    text: "Tax-exempt up to $300. Employer pays Fringe Benefit Tax on excess amount.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.RECREATIONAL_FACILITIES_AND_DUES]: {
    text: "Employee receives the benefit tax-free. Employer pays Fringe Benefit Tax.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
